import React, { createContext, useEffect, useRef, useState } from "react";
import { AppState } from "react-native";

type RefreshContextType = {
  refreshTrigger: number;
};

export const RefreshContext = createContext<RefreshContextType>({
  refreshTrigger: 0,
});

type Props = {
  children: React.ReactNode;
};

export const RefreshProvider: React.FC<Props> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const appState = useRef(AppState.currentState);
  const isFirstMount = useRef(true);

  useEffect(() => {
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (isFirstMount.current) {
        // First time app loads
        setRefreshTrigger((prev) => prev + 1);
        isFirstMount.current = false;
      } else if (
        appState.current === "background" &&
        nextAppState === "active"
      ) {
        // App comes from background
        setRefreshTrigger((prev) => prev + 1);
      }

      appState.current = nextAppState;
    });

    // Run on mount (cold start) in case AppState change doesn't fire
    if (isFirstMount.current) {
      setRefreshTrigger((prev) => prev + 1);
      isFirstMount.current = false;
    }

    return () => {
      subscription.remove();
    };
  }, []);

  return (
    <RefreshContext.Provider value={{ refreshTrigger }}>
      {children}
    </RefreshContext.Provider>
  );
};
